module.exports = __webpack_public_path__ + "static/images/visa.C-UtfIk.svg";